import {ChatGoogleGenerativeAI} from "@langchain/google-genai";
import {PromptTemplate} from '@langchain/core/prompts';
import {StringOutputParser} from "@langchain/core/output_parsers";

// Este componente es responsable de procesar nuevos mensajes del usuario y obtener una respuesta de OpenAI.
// Utiliza un array de mensajes humano/sistema que se envía continuamente a OpenAI.

export const dynamic = 'force-dynamic';

const formatMessage = (input) => {
    return `${input.type}: ${input.message}`;
};

const TEMPLATE =
    `Eres Fabrizzio, un asistente virtual de izzi para ayudar a los vendedores a gestionar órdenes de compra. Guías paso a paso en el proceso de ventas, capturando datos, seleccionando productos adecuados y cumpliendo requisitos del cliente. Respondes de forma clara, profesional y concisa, detectando y corrigiendo errores. Priorizas la satisfacción del cliente.

    Conversación actual:
    {chat_history}
    
    usuario: {input}
    bot:`;

    const LangchainProcessor = async (newMessage, previousMessages) => {
        try {
            const formattedPreviousMessages = previousMessages.map(formatMessage);
    
            const prompt = PromptTemplate.fromTemplate(TEMPLATE);
    
            // Configuración del modelo ChatOpenAI
            const model = new ChatGoogleGenerativeAI({
                maxOutputTokens: 32,
                apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
                verbose: true,
            });
    
            const parser = new StringOutputParser();
    
            const chain = prompt.pipe(model).pipe(parser);
    
            const result = await chain.invoke({
                chat_history: formattedPreviousMessages.join('\n'),
                input: newMessage,
            });
    
            // Si el resultado es un Response, conviértelo en JSON o texto
            if (result instanceof Response) {
                if (result.headers.get('content-type')?.includes('application/json')) {
                    return await result.json();
                } else {
                    return await result.text();
                }
            }
    
            return result;
        } catch (error) {
            // Devuelve un objeto simple en lugar de un Response
            return {
                error: error.message,
                status: error.status ?? 500
            };
        }
    };
    

export default LangchainProcessor;
